// 4ロール（各ユーザーは原則1ロール）。設計§2.1/§3。
export enum Role {
  TenantAdmin = "tenant-admin",
  Operator = "operator",
  CostViewer = "cost-viewer",
  DashboardViewer = "dashboard-viewer",
}

// 高権限（ロールと直交する追加権限グループ）。設計§3.2。
export enum PrivilegedGroup {
  SfDiagnostic = "privileged-sf-diagnostic",
  GwDiagnostic = "privileged-gw-diagnostic",
}
